const TileType = {
  RIGHT: "RIGHT",
  SUBRIGHT: "SUBRIGHT",
  LEARNMORE: "LEARNMORE",
};
export default TileType;
